import { attribute, Component, type Deps, type Emits } from "@bodil/dom/component";
import type { Role } from "aria-attribute-types";
import { html } from "lit";
import { customElement } from "lit/decorators.js";

import { BcIcon } from "./icon";

import styles from "./help.css?inline";

declare global {
    interface HTMLElementTagNameMap {
        "bc-help": BcHelp;
    }
}

@customElement("bc-help")
export class BcHelp extends Component {
    emits!: Emits<"close">;

    static deps: Deps = [BcIcon];

    @attribute accessor role: Role = "note";

    protected override render(): unknown {
        return html`
            <h2>
                Cheat Sheet
                <button>
                    <bc-icon name="close" @click=${() => this.emit("close")}></bc-icon>
                </button>
            </h2>
            <p>Arithmetic:</p>
            <dl>
                <dt>2 + 2</dt>
                <dd>4</dd>
                <dt>1.5 * 3.2 / 2.4</dt>
                <dd>2</dd>
                <dt>(2 + 3) * (5 - 2)</dt>
                <dd>15</dd>
                <dt>2 ^ 8</dt>
                <dd>256</dd>
                <dt>sqrt(9)</dt>
                <dd>3</dd>
            </dl>
            <p>Variables:</p>
            <dl>
                <dt>x = 3</dt>
                <dd>3</dd>
                <dt>y = 5</dt>
                <dd>5</dd>
                <dt>2x + y</dt>
                <dd>11</dd>
            </dl>
            <p>Functions:</p>
            <dl>
                <dt>f(x, y) = x ^ y</dt>
                <dd>f(x, y)</dd>
                <dt>f(2, 5)</dt>
                <dd>32</dd>
            </dl>
            <p>Units:</p>
            <dl>
                <dt>a = 5.08cm + 2in</dt>
                <dd>10.16 cm</dd>
                <dt>a to inch</dt>
                <dd>4 inch</dd>
                <dt>2kW * 2h</dt>
                <dd>14.4 MJ</dD>
            </dl>
            <p>Trigonometry:</p>
            <dl>
                <dt>sin(90 deg)</dt>
                <dd>1</dd>
                <dt>cos(180 deg)</dt>
                <dd>-1</dd>
                <dt>area(r) = pi r^2</dt>
                <dd>area(r)</dd>
                <dt>a(3)</dt>
                <dd>28.2743…</dd>
            </dl>
            <p>Matrices:</p>
            <dl>
                <dt>[1,2;3,4] * [5,6]</dt>
                <dd>[17, 39]</dd>
            </dl>
            <p>Base 16:</p>
            <dl>
                <dt>0x1234 & 0x0ff0</dt>
                <dd>560</dd>
                <dt>hex(0x1234 & 0x0ff0)</dt>
                <dd>0x230</dd>
            </dl>
            <p>More:</p>
            <p><a href="https://mathjs.org/docs/index.html" target="_blank">MathJS documentation</a></p>
        `;
    }

    static styles = styles;
}
